import { gql } from "@/services/httpAdapter";

export const salesLeadFragment = gql`
	fragment SalesLead on SalesLead {
		_id
		locationId
		commissionCycleId
		payPeriodId
		bodId
		nameRecId
		creationDateTime
		leadDate
		branchId
		storeId
		individualCustomer
		businessCustomer
		prospectCategory
		providerName
		providerService
		isCiLead
		prospectType
		prospectStatus
		prospectStatusType
		primarySalesPerson
		secondarySalesPerson
		manager
		bdcUser
		prospectId
		insertedBy
		prospectNote {
			header
			content
		}
		phoneNumbers {
			type
			extension
			number
		}
		email {
			mailTo
		}
		consent {
			email
			text
			phone
			optOut
			optOutUse
		}
		desiredVehicle {
			stockType
			vin
			vehicleYear
			vehicleMake
			vehicleModel
			vehicleStyle
			stockId
		}
		potentialTrade {
			tradeVehicleVin
			tradeVehicleYear
			tradeVehicleMake
			tradeVehicleModel
			tradeVehicleOdometer
		}
		createdAt
		updatedAt
		customerName
		inStoreDate
		hasOEMEvent
		lastActivity {
			eventId
			eventName
			creationDateTime
		}
		responseStatus
	}
`;

export const salesLeadCustomerFragment = gql`
	fragment SalesLeadCustomer on SalesLeadCustomer {
		_id
		locationId
		nameRecId
		ibFlag
		sendTextsTo
		createdAt
		updatedAt
		lastName
		firstName
		midName
		prefContact
		businessName
		contactFirstName
		contactLastName
		phoneNumbers {
			type
			extension
			number
		}
		email {
			mailTo
		}
	}
`;

export const leadDispositionFragment = gql`
	fragment LeadDisposition on LeadDisposition {
		_id
		locationId
		commissionCycleId
		payPeriodId
		destinationCode
		prospectId
		nameIdentification
		event {
			id
			name
		}
		userIdCompletedBy
		completedOn
		prospectIdMerged
		vinNumber
		stockType
		primarySalesperson
		appointment {
			startDate
			endDate
		}
	}
`;
